<div class="container mt-3" *ngFor="let _optional of day.optionals"
  [class.d-none]="getVisibleOptionals(_optional.optionals).length === 0">
  <ng-container *ngFor="let optional of getVisibleOptionals(_optional.optionals)">
    <div class="row" [id]="optional?.code ? 'svc-' + optional.code : null">
      <div class="col-xs-12 col-md-4">
        <img class="img-fluid service-photo" [src]="optional.image || getActivityImage(optional.category)" alt="Optional" [fallbackSrc]="defaultImage || noImageUrl"
          [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <h5>
              <span class="text-capitalize">{{ decodeHtml(optional.type?.toLowerCase()) }}</span>
            </h5>
          </div>
          <div class="col-xs-12 col-md-4">
            <app-pnr [pnr]="optional?.pnr" [supplierName]="optional?.supplierName"></app-pnr>
          </div>
        </div>
        <div class="itinerary-content">
          <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getActivityIcon(optional.category) || getServiceIconPath('landmark')"></app-service-icon></span>
          <h6>
            <span class="text-capitalize">{{ decodeHtml(optional.name?.toLowerCase()) }}</span>
          </h6>
        </div>
        <div class="itinerary-content">
          <div class="itinerary-adress">
            <span class="itinerary-icons"><em class="fas fa-map-marker-alt"></em></span>
            <h6>
              <span class="text-capitalize">{{ optional?.city_name}}</span>
              <span class="subservice--name" *ngIf="!!optional.items.length"> | <small>{{ optional.items[0]?.name
                  }}</small></span>
            </h6>
          </div>
        </div>
        <div class="itinerary-content">
          <div class="itinerary-night">
            <span class="itinerary-icons"><em class="fas fa-calendar-alt"></em></span>
            <h6>
              <span class="text-capitalize">{{ optional?.date | localizedDate: "dd MMM" }}</span>
            </h6>
          </div>
        </div>
        <div class="itinerary-content">
          <div class="itinerary-night">
            <span class="itinerary-icons"><em class="fas fa-male"></em></span>
            <h6>
              <span class="text-lowercase">
                {{ optional?.items[0].adults?.totalNumber }} {{ "ITINERARY.PAX-TYPE.ADT" | translate }}
                <ng-container *ngIf="optional?.items[0].children">
                  {{ optional?.items[0].children?.totalNumber }} {{ "ITINERARY.PAX-TYPE.CHD" | translate }}
                </ng-container>
              </span>
            </h6>
          </div>
        </div>

        <p class="m-0 text-default" *ngIf="!replaceShowDescriptionButtonWithNotes && _optional?.notes">
          <ng-container *ngFor="let item of _optional?.notes">
            <ng-container *ngIf="state === 'Preventivo'">
              <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
                <span [innerHTML]="item.text | safeHtml"></span>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="state === 'Confermata'">
              <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
                <span [innerHTML]="item.text | safeHtml"></span>
              </ng-container>
            </ng-container>
          </ng-container>
        </p>

        <div class="service-items" *ngIf="hasSupplementsAndReductions(optional)">
          <div class="item-detail" *ngFor="let item of getSupplementsAndReductions(optional)">
            <p class="text-primary" *ngIf="item?.text && item.text.trim()">
              <small>• {{ item.text }}</small>
            </p>
          </div>
        </div>

        <ng-container *ngIf="replaceShowDescriptionButtonWithNotes; else optionalDescriptionToggle">
          <span *ngIf="optional.description" [innerHTML]="optional.description | safeHtml"></span>
          <details class="details details-optional" *ngIf="getFilteredNotes(_optional.notes).length > 0">
            <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
              attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
            </summary>
            <div class="row">
              <div class="col-12">
                <ng-container *ngFor="let item of getFilteredNotes(_optional.notes)">
                  <span [innerHTML]="item.text | safeHtml"></span>
                </ng-container>
              </div>
            </div>
          </details>
        </ng-container>
        <ng-template #optionalDescriptionToggle>
        <ng-container *ngIf="optional.description != ''">
          <details class="details details-optional"><!-- text-muted small -->
            <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
              attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
            </summary>
            <div class="row">
              <div class="col-12">
                <span [innerHTML]="optional.description | safeHtml"></span>
              </div>
            </div>
          </details>
        </ng-container>
        </ng-template>

        <app-carousel-images [images]="optional.images"></app-carousel-images>
      </div>
    </div>
    <div class="col-12 mt-2 mb-2" *ngIf="day.flights != '' && day.isLastDay != false || day.optionalsSuggested">
      <hr class="line-grey">
    </div>
  </ng-container>
</div>

<!-- Optional Suggested -->
<ng-container *ngIf="showOptionlServices">
  <div *ngFor="let _optional of day.optionalsSuggested">
    <div class="container mt-3" [class.d-none]="getVisibleOptionals(_optional.optionals).length === 0">
      <ng-container *ngFor="let optional of getVisibleOptionals(_optional.optionals)">
        <div class="row" [id]="optional?.code ? 'svc-' + optional.code : null">
          <div class="col-xs-12 col-md-4">
            <img class="img-fluid service-photo" [src]="optional.image || getActivityImage(optional.category)" alt="Optional" [fallbackSrc]="defaultImage || noImageUrl"
              [secondaryFallback]="'assets/custom/' + version + '/images/logo_tour_operator.png'">

            <div class="btn-optionalServices --optionAlternatives">
              <div class="text">
                <p>{{ 'ITINERARY.ALTERNATIVES-BUTTON' | translate }}</p>
              </div>
              <div class="icon">
                <svg width="35" height="31" viewBox="0 0 35 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M30.6249 16.1179V14.0412C30.6249 10.5602 29.2421 7.22184 26.7807 4.76042C24.3192 2.29901 20.9808 0.916199 17.4999 0.916199C14.0189 0.916199 10.6805 2.29901 8.2191 4.76042C5.75768 7.22184 4.37488 10.5602 4.37488 14.0412V16.1179C2.84532 16.7914 1.59354 17.9699 0.829117 19.4561C0.0646893 20.9423 -0.165992 22.646 0.17569 24.282C0.517373 25.9179 1.41068 27.3869 2.70606 28.4429C4.00145 29.4989 5.62027 30.0779 7.29154 30.0829C8.06509 30.0829 8.80696 29.7756 9.35394 29.2286C9.90092 28.6816 10.2082 27.9397 10.2082 27.1662V18.4162C10.2082 17.6427 9.90092 16.9008 9.35394 16.3538C8.80696 15.8068 8.06509 15.4995 7.29154 15.4995V14.0412C7.29154 11.3338 8.36706 8.73725 10.2815 6.82282C12.1959 4.90838 14.7925 3.83287 17.4999 3.83287C20.2073 3.83287 22.8038 4.90838 24.7183 6.82282C26.6327 8.73725 27.7082 11.3338 27.7082 14.0412V15.4995C26.9347 15.4995 26.1928 15.8068 25.6458 16.3538C25.0988 16.9008 24.7915 17.6427 24.7915 18.4162V27.1662H20.4165C20.0298 27.1662 19.6588 27.3198 19.3853 27.5933C19.1119 27.8668 18.9582 28.2378 18.9582 28.6245C18.9582 29.0113 19.1119 29.3822 19.3853 29.6557C19.6588 29.9292 20.0298 30.0829 20.4165 30.0829H27.7082C29.3795 30.0779 30.9983 29.4989 32.2937 28.4429C33.5891 27.3869 34.4824 25.9179 34.8241 24.282C35.1657 22.646 34.9351 20.9423 34.1706 19.4561C33.4062 17.9699 32.1544 16.7914 30.6249 16.1179V16.1179ZM7.29154 27.1662C6.13122 27.1662 5.01842 26.7053 4.19795 25.8848C3.37748 25.0643 2.91654 23.9515 2.91654 22.7912C2.91654 21.6309 3.37748 20.5181 4.19795 19.6976C5.01842 18.8771 6.13122 18.4162 7.29154 18.4162V27.1662ZM27.7082 27.1662V18.4162C28.8685 18.4162 29.9813 18.8771 30.8018 19.6976C31.6223 20.5181 32.0832 21.6309 32.0832 22.7912C32.0832 23.9515 31.6223 25.0643 30.8018 25.8848C29.9813 26.7053 28.8685 27.1662 27.7082 27.1662Z"
                    fill="white" />
                </svg>
              </div>
            </div>

          </div>
          <div class="col-xs-12 col-md-8">
            <div class="row">
              <div class="col-xs-12 col-md-8">
                <h5>
                  <span class="text-capitalize">{{ decodeHtml(optional.type?.toLowerCase()) }}</span>
                </h5>
              </div>
              <div class="col-xs-12 col-md-4">
                <app-pnr [pnr]="optional?.pnr" [supplierName]="optional?.SupplierName"></app-pnr>
              </div>
            </div>
            <div class="itinerary-content">
              <span class="itinerary-icons"><app-service-icon [icon]="'landmark'" [customPath]="getActivityIcon(optional.category) || getServiceIconPath('landmark')"></app-service-icon></span>
              <h6>
                <span class="text-capitalize">{{ decodeHtml(optional.name?.toLowerCase()) }}</span>
              </h6>
            </div>
            <div class="itinerary-content">
              <div class="itinerary-adress">
                <span class="itinerary-icons"><em class="fas fa-map-marker-alt"></em></span>
                <h6>
                  <span class="text-capitalize">{{ optional?.city_name}}</span>
                </h6>
              </div>
            </div>
            <div class="itinerary-content">
              <div class="itinerary-night">
                <span class="itinerary-icons"><em class="fas fa-calendar-alt"></em></span>
                <h6>
                  <span class="text-capitalize">{{ optional?.date | localizedDate: "dd MMM" }}</span>
                </h6>
              </div>
            </div>
            <div class="itinerary-content">
              <div class="itinerary-night">
                <span class="itinerary-icons"><em class="fas fa-male"></em></span>
                <h6>
                  <span class="text-lowercase">
                    {{ optional?.items[0].adults?.totalNumber }} {{ "ITINERARY.PAX-TYPE.ADT" | translate }}
                    <ng-container *ngIf="optional?.items[0].children">
                      {{ optional?.items[0].children?.totalNumber }} {{ "ITINERARY.PAX-TYPE.CHD" | translate }}
                    </ng-container>
                  </span>
                </h6>
              </div>
            </div>

            <p class="m-0 text-default" *ngIf="!replaceShowDescriptionButtonWithNotes && _optional.notes">
              <ng-container *ngFor="let item of _optional.notes">
                <ng-container *ngIf="state === 'Preventivo'">
                  <ng-container *ngIf="item.id.endsWith('itinerario_preventivo')">
                    <span [innerHTML]="item.text | safeHtml"></span>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="state === 'Confermata'">
                  <ng-container *ngIf="item.id.endsWith('itinerario_conferma')">
                    <span [innerHTML]="item.text | safeHtml"></span>
                  </ng-container>
                </ng-container>
              </ng-container>
            </p>

            <app-carousel-images [images]="optional.images"></app-carousel-images>
          </div>
          <section class="col-12 right" *ngIf="replaceShowDescriptionButtonWithNotes; else suggestedOptionalDescriptionToggle">
            <span *ngIf="optional.description" [innerHTML]="optional.description | safeHtml"></span>
            <details class="details details-optional" *ngIf="getFilteredNotes(_optional.notes).length > 0">
              <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
                attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
              </summary>
              <div class="row">
                <div class="col-12">
                  <ng-container *ngFor="let item of getFilteredNotes(_optional.notes)">
                    <span [innerHTML]="item.text | safeHtml"></span>
                  </ng-container>
                </div>
              </div>
            </details>
          </section>
          <ng-template #suggestedOptionalDescriptionToggle>
          <section class="col-12 right" *ngIf="optional.description != ''">
            <details class="details details-optional">
              <summary class="text-right small" attr.data-open="{{ 'ITINERARY.SHOW' | translate }}"
                attr.data-close="{{ 'ITINERARY.HIDE' | translate }}">
              </summary>
              <div class="row">
                <div class="col-12">
                  <span [innerHTML]="optional.description | safeHtml"></span>
                </div>
              </div>
            </details>
          </section>
          </ng-template>
        </div>
        <div class="col-12 mt-2 mb-2" *ngIf="day.flights != '' && day.isLastDay != false">
          <hr class="line-grey">
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>